module.exports = __webpack_public_path__ + "static/media/iconvideo.bac4321e.svg";